import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

// Define interface for comment data
export interface ENO1Comment {
  date: string;
  ppo: string;
  version: number;
  comment: string;
}

// Define interface for the complete API response
export interface ENO1CommentsResponse {
  inboundRemovalDate: string | null;
  outboundRemovalDate: string | null;
  accountingYear: number;
  accountingQuarter: number;
  comments: ENO1Comment[];
  totalElements?: number;
  totalPages?: number;
  currentPage?: number;
  pageSize?: number;
}

interface UseENO1CommentsParams {
  dataSetId: number;
  enabled?: boolean;
  page?: number;
  size?: number;
}

/**
 * Hook to fetch comments for a specific eNO1 dataset
 * 
 * @param params Dataset ID, enabled flag, and pagination parameters
 * @returns Query result with comments data
 */
export const useENO1Comments = ({ 
  dataSetId, 
  enabled = true, 
  page = 0, 
  size = 5 
}: UseENO1CommentsParams) => {
  return useQuery<ENO1CommentsResponse>({
    queryKey: ['eno1Comments', dataSetId, page, size],
    queryFn: async () => {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString()
      });
      const response = await axios.get(`/data-set/eno1/${dataSetId}/comments?${params}`);
      return response.data;
    },
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
    enabled: enabled && !!dataSetId,
    refetchOnMount: true,
    refetchOnWindowFocus: false
  });
}; 